<template>
    <div class="back-header">
        <div class="header-body-info" v-if="navState">
            <div class="section">
                <em>
                    欢迎您，<i>{{ updataCompanyName }}</i>
                </em>
                <span @click="exit()">退出登录</span>
            </div>
        </div>

        <div class="layout-header">
            <div class="header-banner">
               <div class="logo-box">
                   <img class="logo" src="../../assets/images/logo.png" alt="">
                   <img class="project-name" src="./images/name.png" alt="">
               </div>
            </div>
            <div class="layout-nav">
                <div class="wraper clear">
                    <ul class="nav-list fl">
                        <li
                            v-for="item in navList"
                            :key="item.id"
                            :class="{'active':homeNav == item.id }"
                            @click="changeNav(item)">
                            <router-link :to="{ name: item.pathUrl }">
                                {{ item.name }}
                            </router-link>
                        </li>
                    </ul>
                    <div class="header-more" v-show="navState">
                        <em>hi，<i>{{ updataCompanyName }}</i></em>
                        <span @click="toCenter">进入企业系统</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {removeToken} from '@/assets/js/token.js'
    import {mapMutations} from 'vuex'
    export default {
        name: 'headerBox',
        created() {
            this.homeNav = sessionStorage.getItem('homeNav');
            this.loginState = JSON.parse(localStorage.getItem('loginState'));
            this.companyName = localStorage.getItem("companyName");
            if (this.loginState && this.loginState.name == '企业') {
                this.$store.commit('updataNavState', true);
            } else {
                this.$store.commit('updataNavState', false);
            }
            if (this.companyName) {
                this.$store.commit('updataCompanyName', this.companyName);
            }
        },
        data() {
            return {
                loginState: '',
                isLogin: '',
                companyName: '',
                isPop: 0, //登录弹窗

                homeNav: '', //id
                companyShow: false,
                navList: [ //导航数据
                    {
                        id: '800',
                        name: '首页',
                        pathUrl: 'index',
                    },
                    {
                        id: '300',
                        name: '找资金',
                        pathUrl: 'productionList',
                    },
                    {
                        id: '400',
                        name: '找项目',
                        pathUrl: 'project',
                    },
                    {
                        id: '500',
                        name: '政策新闻',
                        pathUrl: 'dynamic',
                    },
                    // {
                    //     id: '600',
                    //     name: '政策兑现',
                    //     pathUrl: 'discount',
                    // },
                    {
                        id: '600',
                        name: '绿融通',
                        pathUrl: 'green',
                    },
                    {
                        id: '200',
                        name: '平台介绍',
                        pathUrl: 'centerIntroduction',
                    },

                ],
                keywords: '', //搜一搜
                account: '100',
            }
        },
        computed: {
            navState() { //头部一级导航状态
                return this.$store.state.entNavState;
            },
            updataCompanyName() { //企业名称
                return this.$store.state.userInfo.username;
            }
        },
        watch: {
            $route(to) {
                this.homeNav = to.meta.id;
            }
        },
        methods: {
            changeNav(item) { //导航切换
                this.homeNav = item.id;
            },

            // 进入企业系统
            toCenter() {
                if (sessionStorage.getItem('userHasAuth') === 'true') {
                    this.$router.push({
                        name: 'home'
                    })
                } else {
                    this.$router.push({
                        name: 'info'
                    })
                }

            },

            exit() { //退出
                this.clearCompanyInfo();
                this.companyShow = false;
                removeToken();
                localStorage.removeItem('loginState');
                sessionStorage.clear();
                this.$router.push({
                    name: 'index'
                })


            },
            ...mapMutations({
                "clearCompanyInfo": "clearCompanyInfo"
            })
        },
        activated() {

        },
    }
</script>
<!--这里的样式需要调整，加scoped就失效了-->
<style scoped lang="less">
    .header-body-info {
        height: 30px;
        background: #E3E4E5;
    }

    .header-body-info > div {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }

    .header-body-info > div > em {
        font-size: 12px;
        font-weight: 400;
        color: #535353;
        display: flex;
        align-items: center;
    }

    .header-body-info > div > em::after {
        content: "";
        display: inline-block;
        width: 1px;
        height: 14px;
        background: #CDCDCD;
        margin: 0 13px 0 10px;
    }

    .header-body-info > div > em > i {
        cursor: pointer;
    }

    .header-body-info > div > span {
        font-size: 12px;
        font-weight: 400;
        color: #535353;
        cursor: pointer;
    }

    .layout-header {
        height: 320px;
    }

    .li-active {
        cursor: pointer;
    }

    .li-active.active {
        background: #042E79;
    }

    .header-banner {
        height: 280px;
        background: url("./images/header_bg.png") no-repeat center/cover;
        position: relative;

        .logo-box {
            position: absolute;
            width: 1069px;
            height: 118px;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
        }
        img{
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
        }
        .logo{
            left: 0;
            height: 118px;
        }
        .project-name{
            left: 140px;
            height: 80px;
        }
    }

    .layout-nav {
        height: 40px;
        background: #0F43A2;
    }

    .nav-list {
        display: flex;
    }

    .nav-list li {
        float: left;
        width: 150px;
        height: 40px;
    }

    .nav-list li a {
        width: 150px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: url(../../assets/images/nav.jpg) right 10px no-repeat;
        font-family: PingFangSC-Medium, PingFang SC;
        float: left;
        color: #fff;
        font-size: 16px;
    }

    .nav-list li:nth-child(6) a {
        background: none;
    }

    .nav-list li a:hover,
    .nav-list .active a {
        background: #1e4286 url(../../assets/images/nav.jpg) right 10px no-repeat;
    }

    .nav-list li:nth-child(5) a:hover {
        background: #1e4286;
    }
    .nav-list li:nth-child(5).active{
        background: #1e4286;
    }
    .header-right {
        display: flex;
        position: relative;
        width: 180px;
        height: 28px;
        background: #fff;
        border-radius: 2px;
        margin-top: 6px;
        overflow: hidden;
    }

    .header-right i {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        height: 100%;
        width: 32px;
        cursor: pointer;
    }

    .header-right i.icon {
        background: url("../../assets/images/icons/icon-search.png") center center no-repeat;
        background-size: 16px;
    }

    .header-right input {
        height: 28px;
        line-height: 28px;
        position: absolute;
        /* top: 1px; */
        bottom: 1px;
        right: 0px;
        border: none;
        /* height: calc(100% - 2px); */
        width: calc(100% - 32px);
    }

    .header-more {
        width: 300px;
        text-align: right;
        height: 40px;
        line-height: 24px;
        color: #fff;
        overflow: hidden;
        font-size: 14px;
    }

    .header-more > span {
        display: inline-block;
        width: 108px;
        height: 24px;
        border-radius: 2px;
        margin-top: 8px;
        text-align: center;
        border: 1px solid #FFFFFF;
        margin-left: 10px;
        cursor: pointer;
    }
</style>
